import { WritableObservable } from "micro-observables";
import { LocalStorage } from "@core/localStorage/storage";

export class PrivacyService {
	privacyValidated = new WritableObservable(this.privacyStorage?.getItem(false));

	constructor(private readonly privacyStorage: LocalStorage<boolean>) {
		this.privacyValidated.onChange((validated) => this.privacyStorage.setItem(validated));
	}

	acceptPrivacy(): void {
		if (!this.privacyValidated.get()) {
			this.privacyValidated.set(true);
		}
	}
}
